import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditProjectExternalLinkNotificationState = createStateReducer(
  initialState,
  {
    [events.editProjectExternalLinkSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectExternalLink",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editProjectExternalLinkFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectExternalLink",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceEditProjectExternalLinkNotificationState };
